import { Injectable } from '@angular/core';
import { IObtenerFacturasOptions, IPaginacionFactura } from '../models/factura.interface';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FacturaService {
  private endpoint: string = '';

  constructor(private http: HttpClient) {
    this.endpoint = environment.endpointFacturacionElectronica;
  }

  public obtenerListaFacturas(consulta: IObtenerFacturasOptions): Observable<IPaginacionFactura> {
    const url = new URL(`${this.endpoint}/facturas/filtrar`);

    if (consulta.origen) {
      url.searchParams.set('origen', consulta.origen);
    }

    if (consulta?.placa) {
      url.searchParams.set('placa', consulta.placa);
    }

    if (consulta?.noTiquete) {
      url.searchParams.set('noTiquete', consulta.noTiquete);
    }

    if (consulta?.fechaRecaudo) {
      url.searchParams.set('fechaRecaudo', consulta.fechaRecaudo);
    }

    url.searchParams.set('page', (consulta?.page ?? 1).toString());
    url.searchParams.set('size', (consulta?.size ?? 10).toString());
    url.searchParams.set('sort', consulta?.sort ?? 'fechaCreacion;desc');
    
    return this.http.get<IPaginacionFactura>(url.toString());
  }

}